
    import "src/app/AppAdmin/Brands/Warehouses/index.module.scss?farm_css_modules";
    
    export default {"attachmentForm": `attachmentForm-c8e9518c`,"warehousesList": `warehousesList-c8e9518c`}
    